import React from 'react';
import { Button } from '@ui';
import { IconCloseX, IconHamburgerMenu } from '@icons';
import { HEADER_NAV_REGION_ID } from './navRegion';

interface MenuToggleProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  ariaControls?: string;
  ariaExpanded?: boolean;
  menuOpen?: boolean;
}

const MenuToggle: React.FC<MenuToggleProps> = ({
  onClick,
  ariaControls = HEADER_NAV_REGION_ID,
  ariaExpanded,
  menuOpen = false,
}) => (
  <Button
    className='menu-btn'
    id='menuBtn'
    aria-controls={ariaControls}
    aria-expanded={ariaExpanded ?? menuOpen}
    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
    as='button'
    type='button'
    onClick={onClick}
    label={
      menuOpen ? (
        <IconCloseX className='menu-toggle-icon' />
      ) : (
        <IconHamburgerMenu className='menu-toggle-icon' />
      )
    }
  />
);

export default MenuToggle;
